import React, { useState } from 'react';
import { Loader2Icon } from 'lucide-react';
interface MembershipSignInProps {
  submitting: boolean;
  error: string | null;
  onSubmit: (email: string, password: string) => void;
}
const inputStyles = 'mt-2 block w-full rounded-xl border border-charcoal/20 bg-white px-4 py-3 text-base text-charcoal focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-purple-600';

/** Sign-in gate using the existing Supabase Auth sign-in (signInPractitioner). */
export function MembershipSignIn({
  submitting,
  error,
  onSubmit
}: MembershipSignInProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!email.trim() || !password) return;
    onSubmit(email.trim().toLowerCase(), password);
  };
  return <section aria-labelledby="membership-signin-heading" className="max-w-lg rounded-3xl border border-charcoal/10 bg-white px-6 py-8 md:px-9 shadow-[0_18px_50px_-32px_rgba(44,44,44,0.45)]" data-id="element-379" data-mp="3ishdj1rp6jbg">
      <h2 id="membership-signin-heading" className="font-serif text-2xl text-charcoal" data-id="element-380" data-mp="39ilejvdr1t3f">
        Sign in to manage your membership
      </h2>
      <p className="mt-2 text-base text-charcoal/70 leading-relaxed" data-id="element-381" data-mp="3nhcr3dcyr6pg">
        Use the same email and password you use in the Fem Entity app.
      </p>

      <form id="membership-signin-form" noValidate onSubmit={handleSubmit} className="mt-6 grid gap-4" data-id="element-382" data-mp="2vr7xqp7879c3">
        <div data-id="element-383" data-mp="2qs3s28jiftqi">
          <label htmlFor="membership_email" className="text-sm font-medium text-charcoal" data-id="element-384" data-mp="2qsn81jplo81w">
            Email
          </label>
          <input id="membership_email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className={inputStyles} data-id="element-385" data-mp="34kbjrlvxsuic" />
        </div>
        <div data-id="element-386" data-mp="280kkrpigdtio">
          <label htmlFor="membership_password" className="text-sm font-medium text-charcoal" data-id="element-387" data-mp="28145fdzhmw0e">
            Password
          </label>
          <input id="membership_password" name="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className={inputStyles} data-id="element-388" data-mp="az5aej9c36ed" />
        </div>

        {error && <p role="alert" className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800" data-id="element-389" data-mp="3o8kw657i1jh7">
            {error}
          </p>}

        <button type="submit" disabled={submitting || !email.trim() || !password} className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-purple-700 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 ease-out hover:bg-purple-800 disabled:cursor-not-allowed disabled:opacity-60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2" data-id="element-390" data-mp="20b8cdd8hntf">
          {submitting && <Loader2Icon aria-hidden="true" className="h-4 w-4 animate-spin" data-id="element-391" data-mp="32yexau0d5jpb" />}
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </section>;
}